import {alias, createModelSchema} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferBundleDecorationType} from "./SmartOfferBundleDecorationType";

export class SmartOfferBundleDecoration extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.DECORATION);
        this._type = null;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    valid() {

        if (!SmartOfferBundleDecorationType.is(this.type) || SmartOfferBundleDecorationType.isNone(this.type)) {
            return false;
        }

        return super.valid();
    }

    empty() {

        return super.empty();

    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleDecoration());
        } else if (target instanceof SmartOfferBundleDecoration) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleDecoration, {
    _type: alias("type", SmartOfferBundleDecorationType.schema()),
});